// Store vs Auto Quote classification for products. The class lives on the nested
// category (`category.product_class`); anything not explicitly auto_quote is Store.
// Fallbacks cover camelCase / top-level shapes defensively.
export const getProductClass = (item) => {
  const cls = item?.category?.product_class ?? item?.category?.productClass ?? item?.product_class ?? item?.productClass
  return String(cls || '').toUpperCase() === 'AUTO_QUOTE' ? 'AUTO_QUOTE' : 'STORE'
}

export const isAutoQuoteProduct = (item) => getProductClass(item) === 'AUTO_QUOTE'
